import React from 'react'
import HowStartpageWorks from '../how-startpage-works'

const HowStartpageWorksNl = () => {
    return <HowStartpageWorks languageCode="nl" />
}

export default HowStartpageWorksNl
